import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const OvertimeReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [user, setUser] = useState({
    start_date: today,
    end_date: today,
    dept_id: "0",
    overtime_status: "",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const handelInput = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch departments
// ✅ Auto-handle all API response formats
const fetchDepartments = async () => {
  try {
    const res = await axios.get(API_BASE_URL + "/showdepartment", {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });

    let deptData = [];

    if (Array.isArray(res.data)) {
      // Case B: pure array
      deptData = res.data;
    } else if (res.data.departments) {
      // Case A: { departments: [...] }
      deptData = res.data.departments;
    } else if (res.data.data) {
      // Case C: { data: [...] }
      deptData = res.data.data;
    } else {
      toast.error("Unexpected response structure from /showdepartment");
      console.log("Raw Response:", res.data);
    }

    setDepartments(deptData);
  } catch (err) {
    console.error(err);
    toast.error("Failed to load departments");
  }
};

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch report data
  const handleSubmit = async (e) => {
    e.preventDefault();

    // block repeat clicks while a request is already running
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/daily_overtime_report",
        {
          start_date: user.start_date,
          end_date: user.end_date,
          dept_id: user.dept_id,
          overtime_status: user.overtime_status,
          action_type: user.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("Report loaded successfully!", {
        toastId: "overtime-report-success",
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching report data", { toastId: "overtime-report-error" });
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  };

  // ✅ Search + Pagination
  let filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}${item.shift_code}${item.overtime_date}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <div className="card shadow-sm mb-4">
          <div className="card-header with-elements">
            <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
                <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
                <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
              </svg>
              Daily Overtime Report
            </h3>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                {/* From Date */}
              <div className="col-md">
  <label htmlFor="start_date">From Date</label>

  <DatePicker
    selected={user.start_date ? new Date(user.start_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setUser((prev) => ({
        ...prev,
        start_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select From Date"
    className="form-control"
    maxDate={user.end_date ? new Date(user.end_date) : null}
    required
  />
</div>

{/* To Date */}
<div className="col-md">
  <label htmlFor="end_date">To Date</label>

  <DatePicker
    selected={user.end_date ? new Date(user.end_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setUser((prev) => ({
        ...prev,
        end_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control"
    minDate={user.start_date ? new Date(user.start_date) : null}
    required
  />
</div>


                {/* Department */}
                <div className="col-md">
                  <label htmlFor="dept_id">Department</label>
                 <Select
    name="dept_id"
    value={departments
      .map((dept) => ({
        value: dept.department_id || dept.id,
        label: dept.department_name,
      }))
      .find((d) => d.value === user.dept_id) || null}
    onChange={(selected) =>
      handelInput({
        target: { name: "dept_id", value: selected ? selected.value : "" },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
                </div>

                {/* Overtime Status */}
                <div className="col-md">
                  <label htmlFor="overtime_status">Overtime Status</label>
                  <select
                    className="form-control required-select"
                    style={{ height: "38px" }}
                    name="overtime_status"
                    value={user.overtime_status}
                    onChange={handelInput}
                    required
                  >
                    <option value="">Select</option>
                    <option value="2">Approved</option>
                    <option value="3">Rejected</option>
                    <option value="0">Cancelled</option>
                  </select>
                </div>

                {/* Action */}
                {/* <div className="col-md-2">
                  <label htmlFor="action_type">Action</label>
                  <select
                    className="form-control"
                    name="action_type"
                    value={user.action_type}
                    onChange={handelInput}
                  >
                    <option value="Fetch">Show</option>
                  </select>
                </div> */}

                {/* Submit */}
                <div className="col-md-auto">
                  <button type="submit" className="btn btn-primary btn-sm" style={{ height: "38px" }} disabled={loading}>
                    {loading ? "Loading..." : "Get"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Table */}
        <div className="card">
          <h6 className="card-header text-danger">
            Kindly Calculate OT Amount = Per hour * Calc Point
          </h6>
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
           
        <div
  className="d-flex align-items-center gap-2"
  style={{ width: "auto", minWidth: "220px" }}
>
  <DownloadButtons data={filteredItems} filename="Daily Overtime" />
</div>


              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                  className="form-select form-select-sm"
                />
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  style={{ width: "200px" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive sticky-table-wrap">
                <table className="table table-bordered table-striped sticky-table sticky-head-tint sticky-no-freeze-col">
                  <thead>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Shift Code</th>
                      <th>Department</th>
                      <th>No of Hours</th>
                      <th>Calc Point</th>
                      <th>Per Hour</th>
                      <th>Amount</th>
                      <th>Actual Amount</th>
                      <th>Overtime Date</th>
                      <th>Incharge</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.shift_code}</td>
                          <td>{row.department}</td>
                          <td>{row.no_of_hour}</td>
                          <td>{row.calc_point}</td>
                          <td>{row.per_hour}</td>
                          <td>{row.amount}</td>
                          <td>{row.actual_amount}</td>
                          <td>{row.overtime_date}</td>
                          <td>{row.incharge_name}</td>
                          <td>{row.status}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OvertimeReport;
